import Notification from "../../../components/Common/Notification/index";
import * as pantOptionApi from "../../../services/pantoptions";
import {
  ADD_PANTOPTION_FAILURE,
  ADD_PANTOPTION_REQUEST,
  ADD_PANTOPTION_SUCCESS,
  DELETE_PANTOPTION_FAILURE,
  DELETE_PANTOPTION_REQUEST,
  DELETE_PANTOPTION_SUCCESS,
  GET_PANTOPTIONS_FAILURE,
  GET_PANTOPTIONS_REQUEST,
  GET_PANTOPTIONS_SUCCESS,
  GET_SINGLE_PANTOPTION_FAILURE,
  GET_SINGLE_PANTOPTION_REQUEST,
  GET_SINGLE_PANTOPTION_SUCCESS,
  UPDATE_PANTOPTION_FAILURE,
  UPDATE_PANTOPTION_REQUEST,
  UPDATE_PANTOPTION_SUCCESS,
} from "./pantoption.actionType";

export const requestAddPantOption = () => {
  return {
    type: ADD_PANTOPTION_REQUEST,
  };
};

export const addPantOptionSuccess = (data) => {
  return {
    type: ADD_PANTOPTION_SUCCESS,
    data,
  };
};

export const addPantOptionFailure = (message) => {
  return {
    type: ADD_PANTOPTION_FAILURE,
    message,
  };
};

export const addPantOption = (data) => {
  return (dispatch) => {
    dispatch(requestAddPantOption());
    return pantOptionApi
      .addPantOption(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addPantOptionSuccess(data));
        return Notification(
          "",
          `${data.Name} PantOption added Successfully `,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addPantOptionFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetPantOptions = () => {
  return {
    type: GET_PANTOPTIONS_REQUEST,
  };
};

export const getPantOptionsSuccess = (data) => {
  return {
    type: GET_PANTOPTIONS_SUCCESS,
    data,
  };
};

export const getPantOptionsFailure = (message) => {
  return {
    type: GET_PANTOPTIONS_FAILURE,
    message,
  };
};

export const getPantOptions = () => {
  return (dispatch) => {
    dispatch(requestGetPantOptions());
    return pantOptionApi
      .getPantOptions()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getPantOptionsSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getPantOptionsFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSinglePantOption = () => {
  return {
    type: GET_SINGLE_PANTOPTION_REQUEST,
  };
};

export const getSinglePantOptionSuccess = (data) => {
  return {
    type: GET_SINGLE_PANTOPTION_SUCCESS,
    data,
  };
};

export const getSinglePantOptionFailure = (message) => {
  return {
    type: GET_SINGLE_PANTOPTION_FAILURE,
    message,
  };
};

export const getSinglePantOption = (id) => {
  return (dispatch) => {
    dispatch(requestgetSinglePantOption());
    return pantOptionApi
      .getSinglePantOption(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSinglePantOptionSuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSinglePantOptionFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeletePantOption = () => {
  return {
    type: DELETE_PANTOPTION_REQUEST,
  };
};

export const deletePantOptionSuccess = (data) => {
  return {
    type: DELETE_PANTOPTION_SUCCESS,
    data,
  };
};

export const deletePantOptionFailure = (message) => {
  return {
    type: DELETE_PANTOPTION_FAILURE,
    message,
  };
};

export const deletePantOption = (id) => {
  return (dispatch) => {
    dispatch(requestDeletePantOption());
    return pantOptionApi
      .deletePantOption(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deletePantOptionSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deletePantOptionFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdatePantOption = () => {
  return {
    type: UPDATE_PANTOPTION_REQUEST,
  };
};

export const updatePantOptionSuccess = (data) => {
  return {
    type: UPDATE_PANTOPTION_SUCCESS,
    data,
  };
};

export const updatePantOptionFailure = (message) => {
  return {
    type: UPDATE_PANTOPTION_FAILURE,
    message,
  };
};

export const updatePantOption = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdatePantOption());
    return pantOptionApi
      .updatePantOption(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updatePantOptionSuccess(data));
        return Notification(
          "",
          `${data.Name} PantOption updated Successfully `,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updatePantOptionFailure());
        Notification("", errorMessage, "error");
      });
  };
};
